interface SliceCenterParams {
  /**
   * The length of the input range.
   */
  inputLength: number;
  /**
   * The size of the desired slice.
   */
  outputLength: number;
  /**
   * The ideal midpoint of the desired slice.
   */
  outputMid: number;
}

interface SliceCenterReturnType {
  /**
   * The start index of the sliced range, inclusive.
   */
  start: number;
  /**
   * The end index of the sliced range, exclusive.
   */
  end: number;
}

export const sliceCenter = ({ inputLength, outputLength, outputMid }: SliceCenterParams): SliceCenterReturnType => {
  // Determine how many items are available from the source before and after the desired midpoint.
  const itemsBefore = outputMid;
  const itemsAfter = inputLength - outputMid - 1;

  // The total number of additional items is the requested total, minus 1 for the midpoint itself.
  const additionalItemsCount = outputLength - 1;

  // Evenly divide the additional items before and after the midpoint.
  const allowedBefore = Math.ceil(additionalItemsCount / 2);
  const allowedAfter = Math.floor(additionalItemsCount / 2);

  // If one side or the other didn't have enough available items, add the difference to the other
  // side to fill out the list.
  const extraAllowedBefore = Math.max(0, allowedAfter - itemsAfter);
  const extraAllowedAfter = Math.max(0, allowedBefore - itemsBefore);

  // Compute final indices.
  const start = Math.max(0, outputMid - allowedBefore - extraAllowedBefore);
  const end = Math.min(inputLength, outputMid + allowedAfter + extraAllowedAfter + 1);

  return {
    start,
    end,
  };
};
